




import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
})
export default class Tooltip extends Vue {
    @Prop({}) text: string;
    @Prop({}) invisible: boolean;
    tooltipStyle: any = {};
    
    mounted () {
        this.tooltipCheckBleed();
    }

    tooltipCheckBleed(){
        let tooltip = this.$refs.tooltip as Element;
        let tooltipBounds = tooltip.getBoundingClientRect();

        if(tooltipBounds.left < 0){
            this.tooltipStyle.left = "2px";
            this.tooltipStyle.transform ="translate3d(0px,0px,0px)"
        }else if(tooltipBounds.right > window.outerWidth){
            this.tooltipStyle.left = "auto";
            this.tooltipStyle.right = "2px";
            this.tooltipStyle.transform ="translate3d(0px,0px,0px)"
        }

        this.$forceUpdate();
    }
}

